export default "__VITE_ASSET__a8d80205__"